import {
    GET_MASTER_DRIVER_DATA,
    GET_ADD_MASTER_DRIVER_DATA,
    SUCCESS_MESSAGE_MASTER_DRIVER,
    ERROR_MESSAGE_MASTER_DRIVER,
    HIDE_MESSAGE_MASTER_DRIVER,
} from 'constants/ActionTypes';


let INIT_STATE = {
    alertMessageMasterDriver: '',
    successMessageMasterDriver: false,
    errorMessageMasterDriver: false,
    masterDriverData: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_MASTER_DRIVER_DATA: {
            return {
                ...state,
                masterDriverData: action.payload
            }
        }
        case GET_ADD_MASTER_DRIVER_DATA: {
            return {
                ...state,
                masterDriverData: [...state.masterDriverData, action.payload]
            }
        }
        case SUCCESS_MESSAGE_MASTER_DRIVER: {
            return {
                ...state,
                alertMessageMasterDriver: action.payload,
                successMessageMasterDriver: true,
            }
        }
        case ERROR_MESSAGE_MASTER_DRIVER: {
            return {
                ...state,
                alertMessageMasterDriver: action.payload,
                errorMessageMasterDriver: true,
            }
        }
        case HIDE_MESSAGE_MASTER_DRIVER: {
            return {
                ...state,
                alertMessageMasterDriver: '',
                errorMessageMasterDriver: false,
                successMessageMasterDriver: false,
            }
        }
        
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/MasterDriver.js